import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import React from 'react'

import { CONFIG_ENABLE_GLADLY } from '@src/config/env'
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import ContactUs from '@src/quince-site-integrated/src/templates/ContactUs'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import Layout from '../layout'

import ContactUsPage from './contact-us-page'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.CONTACT_US)
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageContactUs(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const PageTemplate = CONFIG_ENABLE_GLADLY ? ContactUsPage : ContactUs

  return <Layout {...props}>{props.pageData ? <PageTemplate data={props.pageData} /> : <SomethingWentWrong />}</Layout>
}
